<template>
  <AccountPanel title="Lista ofert">
    <div class="table-responsive offers">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">nr oferty</th>
          <th scope="col">data dodania</th>
          <th scope="col">termin ważności</th>
          <th scope="col">status</th>
          <th scope="col">netto</th>
          <th scope="col">vat</th>
          <th scope="col">brutto</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="offer in offers">
          <th scope="row">{{offer.id}}</th>
          <td>{{offer.added.substr(0, 10)}}</td>
          <td>{{offer.expire.substr(0, 10)}}</td>
          <td>{{offer.status == "NEW" ? 'Nowa' : 'Wykonana'}}</td>
          <td>{{priceToString(offer.total_net, 'PLN')}}</td>
          <td>{{priceToString(offer.total_tax, 'PLN')}}</td>
          <td>{{priceToString(offer.total_gross, 'PLN')}}</td>
          <td>
            <show-icon @click.native="goToOffer(offer.id)" title="Pokaż szczegóły oferty" />
            <delete-icon @click.native="removeOffer(offer.id)" title="Usuń" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </AccountPanel>
</template>

<script>

  import { mapState } from 'vuex';
  import CalculatePrice from 'redbay-b2b-products/src/product/CalculatePrice'
  import AccountPanel from 'redbay-b2b-account/src/account/AccountPanel.vue'

  import ShowIcon from "vue-material-design-icons/magnify.vue"
  import DeleteIcon from "vue-material-design-icons/delete.vue";


  export default {
    data () {
      return {
        offers: []
      }
    },
    components: {
      DeleteIcon,
      ShowIcon,
      AccountPanel
    },
    methods: {
      ...CalculatePrice(),
      goToOffer(offerId) {
        this.$router.push({ name: 'offerPage',params: {offerId: offerId}});
      },
      async removeOffer(offerId) {
        this.offers = this.offers.filter(o => o.id != offerId);
        this.$store.dispatch('offer/removeOffer', offerId);
      }
    },
    async beforeMount() {
      this.offers = await this.$store.dispatch('offer/offers');
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-offer/src/OfferList.vue